import Svg, { Path } from 'react-native-svg'
import type { SvgProps } from 'react-native-svg'

export function ChevronUp(props: SvgProps) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M6 15L11.2929 9.31461C11.6834 8.89513 12.3166 8.89513 12.7071 9.31461L18 15"
        stroke={props.color ?? '#131214'}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </Svg>
  )
}

export default ChevronUp
